var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 6.93303e-05C26.3888 6.93303e-05 34 7.61124 34 17C34 26.3888 26.3888 34 17 34C7.61124 34 7.05138e-05 26.3888 7.05138e-05 17C-0.0266447 7.63786 7.54117 0.0267846 16.9032 6.93303e-05C16.9355 -2.31101e-05 16.9678 -2.31101e-05 17 6.93303e-05Z",
    fill: "#3BB54A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4172 12.3159L14.3434 24.3897L7.58203 17.6767L10.3349 14.9721L14.3434 18.9324L23.6644 9.61133L26.4172 12.3159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.2e8a65d64ef156e2dd3bd456924ca6cf.svg";
export { ForwardRef as ReactComponent };